export const SIGNUP_SUCCESS="auth/SIGNUP_SUCCESS";
export const SIGNUP_FAILURE="auth/SIGNUP_FAILURE";
export const USER_DETAILS_SUCCESS="auth/USER_DETAILS_SUCCESS";
export const USER_DETAILS_FAILURE="auth/USER_DETAILS_FAILURE";